<span *ngIf="!userId || userId == 0" class="color-red">{{ 'no_claimant_assigned' | translate }}</span>
<span *ngIf="userId && userId > 0">{{ userName }}</span>